"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartoonVideo1Schema = void 0;
exports.CartoonVideo1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/cartoon-video/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "CartoonVideo1",
    "description": "Red Bull Cartoon Video served via the RBMN Tenant in the Cartoon Channel of the Sparkle API",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "const": "rrn:content:ext:services:cartoon-video:1"
        },
        "attributes": {
            "type": "object",
            "properties": {
                "assetId": {
                    "type": "string",
                    "pattern": "^([0-9]+-[0-9]+|AA-[A-Z0-9]{13}|AA[A-Z|0-9]{18})$"
                },
                "VIN": {
                    "type": "string",
                    "pattern": "^MI[0-9]+$"
                }
            },
            "required": [
                "assetId",
                "VIN"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9jYXJ0b29uLXZpZGVvLzEuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsbUJBQW1CLEdBQUc7SUFDakMsS0FBSyxFQUFFLGtGQUFrRjtJQUN6RixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxlQUFlO0lBQ3hCLGFBQWEsRUFBRSw2RkFBNkY7SUFDNUcsTUFBTSxFQUFFLFFBQVE7SUFDaEIsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsT0FBTyxFQUFFLDBDQUEwQztTQUNwRDtRQUNELFlBQVksRUFBRTtZQUNaLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFlBQVksRUFBRTtnQkFDWixTQUFTLEVBQUU7b0JBQ1QsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLFNBQVMsRUFBRSxtREFBbUQ7aUJBQy9EO2dCQUNELEtBQUssRUFBRTtvQkFDTCxNQUFNLEVBQUUsUUFBUTtvQkFDaEIsU0FBUyxFQUFFLFlBQVk7aUJBQ3hCO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsU0FBUztnQkFDVCxLQUFLO2FBQ047U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsWUFBWTtRQUNaLE1BQU07S0FDUDtDQUNGLENBQUEifQ==